import { client } from './index';
import { IAcceptQuoteRequest, IAcceptQuoteResponse, IQuote } from '../domains/quote.domain';

const PREFIX = '/tenants/';

export const getQuote = (tenantId: string, quoteShortCode: string): Promise<IQuote> =>
  client.get(`${PREFIX}${tenantId}/quote/${quoteShortCode}`).then(response => response.data);

export const getQuotePreview = (tenantId: string, quoteShortCode: string): Promise<IQuote> =>
  client.get(`${PREFIX}${tenantId}/quote/${quoteShortCode}?isPreview=true`).then(response => response.data);

export const acceptQuote = (tenantId: string, quoteShortCode: string, request: IAcceptQuoteRequest): Promise<IAcceptQuoteResponse> =>
  client.post(`${PREFIX}${tenantId}/quote/${quoteShortCode}/accept`, request).then(response => response.data);
